import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App.js';
import { ConfirmProvider } from './components/ui/ConfirmDialog.js';
import { AdminLocaleProvider } from './lib/admin-locale.js';
import { SessionProvider } from './lib/session.js';
import { ThemeProvider } from './lib/theme.js';
import { UiPrefsProvider } from './lib/ui-prefs.js';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <SessionProvider>
          <AdminLocaleProvider>
            <UiPrefsProvider>
              <ConfirmProvider>
                <App />
              </ConfirmProvider>
            </UiPrefsProvider>
          </AdminLocaleProvider>
        </SessionProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
